import { render, staticRenderFns } from "./Textual.vue?vue&type=template&id=7bddbfb2&scoped=true&"
import script from "./Textual.vue?vue&type=script&lang=js&"
export * from "./Textual.vue?vue&type=script&lang=js&"
import style0 from "./Textual.vue?vue&type=style&index=0&id=7bddbfb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bddbfb2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/frontend/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bddbfb2')) {
      api.createRecord('7bddbfb2', component.options)
    } else {
      api.reload('7bddbfb2', component.options)
    }
    module.hot.accept("./Textual.vue?vue&type=template&id=7bddbfb2&scoped=true&", function () {
      api.rerender('7bddbfb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "@shared/Charts/Layouts/components/Textual.vue"
export default component.exports